import React from 'react';

const ITEM_SLOTS = 12;

const ItemGrid = ({ player, setHoveredItem }) => {
    const items = Array.isArray(player?.items) ? player.items : [];
    const filled = [...items].slice(0, ITEM_SLOTS);
    while (filled.length < ITEM_SLOTS) filled.push(null);
    const heroId = player?.hero_id;

    return (
        <div className="overlay-items">
            {filled.map((it, idx) => {
                const src = it?.shop_image_small || it?.shop_image || it?.image;
                return (
                    <div
                        key={`item-${idx}`}
                        className={`overlay-item ${src ? 'has' : 'empty'}`}
                        onMouseEnter={src ? (e) => {
                            setHoveredItem({ item: it, x: e.clientX, y: e.clientY, heroId });
                        } : undefined}
                        onMouseMove={src ? (e) => {
                            setHoveredItem(prev => prev ? { ...prev, x: e.clientX, y: e.clientY } : null);
                        } : undefined}
                        onMouseLeave={src ? () => setHoveredItem(null) : undefined}
                    >
                        {src ? <img src={src} alt={it?.name || `Item ${idx + 1}`} /> : null}
                    </div>
                );
            })}
        </div>
    );
};

export default ItemGrid;
